<db-button [design]="buttondesign" [type]="buttonType" (click)="click()">
  {{ label | translate }}
</db-button>
